var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user_main_settings" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-5" }, [
      _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 col-xl-4 pb-4" }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v("\n\t\t\t\t\tСлужбові записки\n\t\t\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "organization" } },
            [_vm._v("\n\t\t\t\t\t\tОрганізація за замовчуванням\n\t\t\t\t\t")]
          ),
          _vm._v(" "),
          _vm.organizations.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        reduce: (organization) => organization.id,
                        label: "small_title",
                        options: this.organizations,
                        filterable: true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-flex p-1 mr-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-3x opacity-100 color-primary-500",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-2x opacity-100 color-primary-300",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fal fa-bookmark icon-stack-1x opacity-100 color-white",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "org_title ml-2" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.small_title) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2147946264
                      ),
                      model: {
                        value: _vm.user.org_def,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "org_def", $$v)
                        },
                        expression: "user.org_def",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\tОберіть організацію\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "service" } },
            [_vm._v("\n\t\t\t\t\t\tСлужба за замовчуванням\n\t\t\t\t\t")]
          ),
          _vm._v(" "),
          _vm.services.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        reduce: (service) => service.id,
                        label: "title",
                        options: this.services,
                        filterable: true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-flex p-1 mr-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-3x opacity-100 color-primary-500",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-2x opacity-100 color-primary-300",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fal fa-bookmark icon-stack-1x opacity-100 color-white",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "org_title ml-2" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.title) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1833006008
                      ),
                      model: {
                        value: _vm.user.service_def,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "service_def", $$v)
                        },
                        expression: "user.service_def",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\tОберіть службу\n\t\t\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(
              "\n\t\t\t\t\t\tПовідомлення службових по e-mail\n\t\t\t\t\t"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: [
                    { text: "ТАК", value: 1 },
                    { text: "НІ", value: 0 },
                  ],
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.user.email_send,
                  callback: function ($$v) {
                    _vm.$set(_vm.user, "email_send", $$v)
                  },
                  expression: "user.email_send",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 col-xl-4 pb-4" }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v("\n\t\t\t\t\tНалаштування Аукціону землі\n\t\t\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(
              "\n\t\t\t\t\t\tУчасник продажу ЗД співробітнику ІМК\n\t\t\t\t\t"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: [
                    { text: "ТАК", value: 1 },
                    { text: "НІ", value: 0 },
                  ],
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.land_settings.auction_in,
                  callback: function ($$v) {
                    _vm.$set(_vm.land_settings, "auction_in", $$v)
                  },
                  expression: "land_settings.auction_in",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "basic-url" } },
            [_vm._v("Фільтр дохідності % >=")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "form-control",
                attrs: { placeholder: "Фільтр дохідності % >=" },
                model: {
                  value: _vm.land_settings.auction_percent,
                  callback: function ($$v) {
                    _vm.$set(_vm.land_settings, "auction_percent", $$v)
                  },
                  expression: "land_settings.auction_percent",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "service" } },
            [
              _vm._v(
                "\n\t\t\t\t\t\tОрганізації, де Ви хочете придбати землю\n\t\t\t\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _vm.organizations.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        multiple: "",
                        reduce: (organization) => organization.id,
                        label: "small_title",
                        options: this.organizations,
                        filterable: true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-flex p-1 mr-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-3x opacity-100 color-primary-500",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "base base-7 icon-stack-2x opacity-100 color-primary-300",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fal fa-bookmark icon-stack-1x opacity-100 color-white",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "org_title ml-2" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.small_title) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3734053272
                      ),
                      model: {
                        value: _vm.land_settings.tovs_auction,
                        callback: function ($$v) {
                          _vm.$set(_vm.land_settings, "tovs_auction", $$v)
                        },
                        expression: "land_settings.tovs_auction",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\tОберіть Організацію\n\t\t\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "next_step text-right" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-lg btn-outline-primary waves-effect waves-themed save_user_settings",
          attrs: { type: "button" },
          on: { click: _vm.save_settings },
        },
        [
          _c("span", { staticClass: "fal fa-check mr-1" }),
          _vm._v("\n\t\t\t\tЗберегти\n\t\t\t"),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-start w-100" }, [
      _c("div", { staticClass: "mr-2 hidden-md-down" }, [
        _c("span", { staticClass: "icon-stack icon-stack-lg" }, [
          _c("i", {
            staticClass:
              "base base-6 icon-stack-3x opacity-100 color-primary-500",
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "ni ni-phone icon-stack-1x opacity-100 color-white",
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-fill" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _c("span", { staticClass: "h5" }, [
            _vm._v("Налаштування параметрів користувача"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v(" % ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }